import API from '@/api'
import AuthTokenResponseDTO from './models/AuthTokenResponseDTO'
export const getAuthToken = async (code: string): Promise<AuthTokenResponseDTO> => {
  return await API.AuthTokenRepository.getAuthToken(code)
}

export const getRefreshToken = async (token: string): Promise<any> => {
  return await API.AuthTokenRepository.getRefreshToken(token)
}
